// extracted by css-extract-rspack-plugin
module.exports =  {"postcode":"PostcodeInput__postcode--std5E","firstCode":"PostcodeInput__firstCode--Bdsos","lastCode":"PostcodeInput__lastCode--zXIbG"};